import { domReady } from '../modules/utils.js';

class ContentAccordion extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = {
      items: [...this.querySelectorAll('.contentaccordion-item')],
    };
    this.#setListeners();
  }

  disconnectedCallback() {
    this.#unsetListeners();
  }

  #setListeners() {
    this.addEventListener('click', this.#onClick);
  }

  #unsetListeners() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const toggle = event.target.closest('.contentaccordion-toggle');
    if (!toggle) return;

    const item = toggle.closest('.contentaccordion-item');
    if (!item) return;

    const isOpen = item.hasAttribute('data-open');

    for (const el of this.refs.items) {
      el.removeAttribute('data-open');
    }

    if (!isOpen) {
      item.setAttribute('data-open', '');
    }
  };
}

customElements.define('content-accordion', ContentAccordion);
